import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Icon } from '../../common/components/Utilities';
import PeopleLayout from '../layout/PeopleLayout';
import UserPill from '../../common/components/UserPill';

function UserChecklist(props) {
  return <PeopleLayout {...props} content={<UserChecklistShow {...props} />} />;
}

function UserChecklistShow({ user }) {
  let roleAction;
  let managerAction;
  let squadAction;
  let startDateAction;

  if (user.job && user.job.id) {
    roleAction = user.job.title;
  } else {
    roleAction = <a className="btn btn-outline-success" href={`/users/${user.id}/edit`}>Assign</a>;
  }

  if (user.manager && user.manager.id) {
    managerAction = <UserPill user={user.manager} />;
  } else {
    managerAction = <a className="btn btn-outline-success" href={`/users/${user.id}/edit`}>Assign</a>;
  }

  if (user.squads.length) {
    const squadActions = user.squads.map((squad) => <div><a href={`/squads/${squad.id}`}>{squad.name}</a></div>);
    squadAction = squadActions;
  } else {
    squadAction = <a className="btn btn-outline-success" href={`/users/${user.id}/edit`}>Assign</a>;
  }

  if (user.start_date) {
    startDateAction = moment(user.start_date).format('dddd D MMMM');
  } else {
    startDateAction = <a className="btn btn-outline-success" href={`/users/${user.id}/edit`}>Assign</a>;
  }

  return (
    <div className="row">
      <div className="col-8 offset-2">
        <UserCheck
          completed={user.job && user.job.id}
          title="Assign a Role"
          description="Make sure the new starter is assigned a role."
          action={roleAction}
        />

        <UserCheck
          completed={user.start_date}
          title="Start Date"
          description="Assign a start date."
          action={startDateAction}
        />

        <UserCheck
          completed={user.manager && user.manager.id}
          title="Assign a Team Lead"
          description="Make sure the new starter is assigned a team lead."
          action={managerAction}
        />

        <UserCheck
          completed={user.squads.length}
          title="Assign a Squad"
          description="Make sure the new starter is assigned to a squad."
          action={squadAction}
        />

        <SlackCheck user={user} />
        <JumpcloudCheck user={user} />
        <ContactCheck user={user} />
        <EmergencyCheck user={user} />
      </div>
    </div>
  );
}

function UserCheck({
  completed, title, description, action, loading = false,
}) {
  let checkAction = action;
  let icon = <Icon icon="spinner text-warning" append="fa-spin fa-fw" size="3x" />;

  if (!loading) {
    icon = <Icon icon={completed ? 'check text-success' : 'times text-danger'} append="fa-fw" size="3x" />;
  } else {
    checkAction = '';
  }

  return (
    <div className="card mb-2">
      <div className="card-body">
        <div className="row">
          <div className="col col-1">{icon}</div>

          <div className="col col-8">
            <div><strong>{title}</strong></div>
            <div className="text-muted">{description}</div>
          </div>

          <div className="col col-3">
            {checkAction}
          </div>
        </div>
      </div>
    </div>
  );
}

function SlackCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-slack`}
      title="Invite to Slack"
      description="Invite the new starter to Slack."
      action={<a target="_blank" className="btn btn-outline-success" href="https://g4m.slack.com/admin/invites" rel="noreferrer">Send Invite</a>}
    />
  );
}

function JumpcloudCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-jumpcloud`}
      title="Create Jumpcloud Account"
      description="Create an account in Jumpcloud."
      action={<a target="_blank" className="btn btn-outline-success" href="https://console.jumpcloud.com/#/users/add" rel="noreferrer">Add User</a>}
    />
  );
}

function ContactCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-contact`}
      title="Personal contact information"
      description="Ensure we have a record of the new starter's personal contact information."
      action={<a className="btn btn-outline-success" href={`/users/${user.id}/edit`}>Add Details</a>}
    />
  );
}

function EmergencyCheck({ user }) {
  return (
    <EndpointCheck
      user={user}
      endpoint={`/users/${user.id}/checklist-emergency`}
      title="Emergency contact information"
      description="Ensure we have a record of the new starter's emergency (next of kin) contact information."
      action={<a className="btn btn-outline-success" href={`/users/${user.id}/edit`}>Add Details</a>}
    />
  );
}

function EndpointCheck({
  user, endpoint, title = '', description = '', action = '',
}) {
  const [isOK, setIsOK] = useState(null);
  const [loading, setLoading] = useState(false);
  let checkAction = action;

  if (isOK) {
    checkAction = '';
  }

  const checkEndpoint = async () => {
    setLoading(true);

    try {
      const response = await Axios.get(endpoint);
      setIsOK(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { checkEndpoint(); }, [user]);

  return (
    <UserCheck
      loading={loading}
      completed={isOK}
      title={title}
      description={description}
      action={checkAction}
    />
  );
}

export default UserChecklist;
